import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const t = {
  en: { login: 'LOGIN', flag: '🇬🇧', lang: 'EN' },
  de: { login: 'LOGIN', flag: '🇩🇪', lang: 'DE' },
};

export default function Header({ lang, onToggleLang }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const tx = t[lang];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'py-3' : 'py-5'
      }`}
      style={{
        backgroundColor: scrolled ? 'rgba(15,17,23,0.95)' : 'transparent',
        backdropFilter: scrolled ? 'blur(12px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(59,130,246,0.15)' : 'none',
      }}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2 group">
          <span
            className="text-2xl font-black tracking-tighter uppercase"
            style={{ color: '#3b82f6', letterSpacing: '-0.03em' }}
          >
            True
          </span>
          <span className="text-2xl font-black tracking-tighter uppercase text-white" style={{ letterSpacing: '-0.03em' }}>
            Fitness
          </span>
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-4">
          {/* Language toggle */}
          <button
            onClick={onToggleLang}
            className="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-semibold transition-all duration-200 hover:bg-white/10"
            style={{ color: '#94a3b8', letterSpacing: '0.05em' }}
          >
            <span className="text-base">{tx.flag}</span>
            <span>{tx.lang}</span>
          </button>

          {/* Login */}
          <a
            href="/s"
            className="px-5 py-2 rounded-md text-sm font-bold uppercase tracking-widest transition-all duration-200 hover:bg-blue-500 hover:text-white"
            style={{
              border: '1.5px solid #3b82f6',
              color: '#3b82f6',
              letterSpacing: '0.1em',
            }}
          >
            {tx.login}
          </a>
        </div>

        {/* Mobile menu button */}
        <div className="flex md:hidden items-center gap-3">
          <button
            onClick={onToggleLang}
            className="flex items-center gap-1 text-sm font-semibold"
            style={{ color: '#94a3b8' }}
          >
            <span>{tx.flag}</span>
          </button>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="p-2 rounded-md transition-colors hover:bg-white/10"
            style={{ color: '#94a3b8' }}
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div
          className="md:hidden mt-2 mx-4 rounded-xl p-4 flex flex-col gap-3"
          style={{ backgroundColor: '#1a1d27', border: '1px solid rgba(59,130,246,0.2)' }}
        >
          <a
            href="/s"
            className="text-center py-2.5 rounded-lg text-sm font-bold uppercase tracking-widest transition-all hover:bg-blue-500 hover:text-white"
            style={{ border: '1.5px solid #3b82f6', color: '#3b82f6', letterSpacing: '0.1em' }}
          >
            {tx.login}
          </a>
        </div>
      )}
    </header>
  );
}
